export enum CarouselDirection {
  Next,
  Previous,
}
